// A random browser credential, not a fingerprint. The server stores only its hash.
// Scope is this origin; clearing site data intentionally makes this a new environment.
export const SUPER_ADMIN_BROWSER_KEY = "superAdminTrustedBrowser.v1";
export const SUPER_ADMIN_EMAIL_NOTICE =
  "Slackに認証リンクを送りました。15分以内に、このブラウザで開いてください。\nシークレットウィンドウの場合は、リンクをコピーして、このウィンドウのURLバーに貼り付けてください。\n確認後は30日間、追加確認を省略します。再送する場合は「ログイン画面に戻る」からやり直してください。";

export type PendingSuperAdminLogin = {
  emailVerificationRequired: true;
  requestLabel?: string;
};

export function getSuperAdminEmailNotice(requestLabel?: string): string {
  return typeof requestLabel === "string" &&
    /^[A-F0-9]{4}-[A-F0-9]{4}$/.test(requestLabel)
    ? `受付番号: ${requestLabel}\nSlackで同じ受付番号のメッセージを開いてください。\n\n${SUPER_ADMIN_EMAIL_NOTICE}`
    : SUPER_ADMIN_EMAIL_NOTICE;
}

export function getLoginEnvironment(app: "school-ai" | "admin", create = true) {
  let browserSecret = "";
  try {
    browserSecret = window.localStorage.getItem(SUPER_ADMIN_BROWSER_KEY) || "";
    if (!/^[a-f0-9]{64}$/.test(browserSecret)) {
      browserSecret = "";
      if (create) {
        const bytes = window.crypto.getRandomValues(new Uint8Array(32));
        browserSecret = Array.from(bytes, byte =>
          byte.toString(16).padStart(2, "0")
        ).join("");
        window.localStorage.setItem(SUPER_ADMIN_BROWSER_KEY, browserSecret);
      }
    }
  } catch {
    // Ordinary users can still sign in; super-admin verification fails closed.
    browserSecret = "";
  }
  return {
    app,
    browserSecret,
    loginPath: /^\/t\/[a-z0-9-]+\/login$/.test(window.location.pathname)
      ? window.location.pathname
      : "/login"
  };
}

export function readAdminLoginLink(): {
  challengeId: string;
  emailSecret: string;
} | null {
  const match = /^#adminLogin=([a-f0-9]{64})\.([a-f0-9]{64})$/.exec(
    window.location.hash
  );
  return match ? { challengeId: match[1], emailSecret: match[2] } : null;
}
